.container {
  padding: 16px;
  max-width: 800px;
}

.subtitle {
  margin-bottom: 24px;
}
